import { Route } from '@angular/router';
import { ProjectTagsViewComponent } from '@app/views/company/projects/project-tags/project-tags-view/project-tags-view.component';
import { ProjectTagsComponent } from '@app/views/company/projects/project-tags/project-tags.component';

export const projectTagsRoutes: Route[] = [
  {
    path: '',
    component: ProjectTagsComponent,
    children: [
      {
        path: '',
        component: ProjectTagsViewComponent
      }
    ]
  }
];
